<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center justify-center">
            {{ $t('successful_registration') }}
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <div class="py-12 px-2 text-center">
          <img src="@/assets/images/svg/register_success.svg" alt="mail" class="img-register_success">
          <h4 class="title font-weight-bold my-5">
            {{ $t('congratulation_you_are_already_registered_as_a_member') }}
          </h4>
          <div class="mt-12">
            <v-btn color="primary" x-large block class="text-none" @click="next()">
              {{ $t('next') }}
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  methods: {
    next() {
      const query = this.$route.query.redirect
      if (query) {
        this.$router.push({ name: query }).catch(() => {})
      } else {
        const astra_outlet = this.$store.state.store_astra
        const tmii_outlet = this.$store.state.store_tmii
        const url_id = this.$store.state.url_domain

        if (tmii_outlet.indexOf(url_id) !== -1) {
          window.location.href = 'https://order.kulinertmii.id'
        } else if (astra_outlet.indexOf(url_id) !== -1) {
          window.location.href = 'https://zestloungemenaraastra.myolsera.com'
        } else {
          this.$router.push({ name: 'home' }).catch(() => {})
        }
      }
    }
  }
}
</script>
